/* eslint-disable max-len */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { GradesAndPromotionsFormViewModel } from 'src/types/GradesAndPromotionsFormViewModel';
import { GradesAndPromotionsModel } from 'src/types/GradesAndPromotionsModel';
import { SelectOption } from 'src/types/SelectOption';
import { thunkExecuteAndReturnResultOrShowError } from '../../services/base.service';
import {
  getGradesAndPromotionsFormViewModel,
  getGradesAndPromotionsSchoolYears,
  getGradesAndPromotionstById,
  getStudentByMSISId,
} from '../../services/gradesAndPromotions.service';

export const fetchGradesAndPromotionsById = createAsyncThunk(
  'input/fetchGradesAndPromotionsById',
  async (stateAgencyIdentifier: string, thunkAPI) => {
    return await thunkExecuteAndReturnResultOrShowError<GradesAndPromotionsModel>(
      thunkAPI,
      getGradesAndPromotionstById(stateAgencyIdentifier, {
        signal: thunkAPI.signal,
      })
    );
  }
);

export const fetchGradesAndPromotionsFormViewModel = createAsyncThunk(
  'input/fetchGradesAndPromotionsFormViewModel',
  async (_, thunkAPI) => {
    return await thunkExecuteAndReturnResultOrShowError<GradesAndPromotionsFormViewModel>(
      thunkAPI,
      getGradesAndPromotionsFormViewModel({ signal: thunkAPI.signal })
    );
  }
);

export const fetchGradesAndPromotionsSchoolYears = createAsyncThunk(
  'input/fetchGradesAndPromotionsSchoolYears',
  async (_, thunkAPI) => {
    return await thunkExecuteAndReturnResultOrShowError<SelectOption[]>(
      thunkAPI,
      getGradesAndPromotionsSchoolYears({ signal: thunkAPI.signal })
    );
  }
);

export const fetchStudentByMSISId = createAsyncThunk(
  'input/fetchStudentByMSISId',
  async (params: { msisId: string; schoolYear: string }, thunkAPI) => {
    const { msisId, schoolYear } = params;
    try {
      const response = await getStudentByMSISId(msisId, schoolYear, {
        signal: thunkAPI.signal,
      });

      // Handle specific error cases
      if (response.status === 409) {
        throw new Error('409');
      } else if (response.status !== 200) {
        throw new Error('NOT_FOUND');
      }

      return response.data;
    } catch (error) {
      if (error instanceof Error) {
        throw error;
      }
      throw new Error('NOT_FOUND');
    }
  }
);
